const equipment = {
    namespaced: true,
    state: {
      isMobile: true,
      pcPageFlag: false,
      widthStyle: false,
      height: {'height':'100vh'}
    },
    mutations: {
      isMobile: function(state, isMobile) {
        state.isMobile = isMobile;
      },
      pcPageFlag: function(state, pcPageFlag) {
        state.pcPageFlag = pcPageFlag;
      },
      widthStyle: function(state, widthStyle) { //pc端打开是失败固定页面宽高
        state.widthStyle = widthStyle;
      },
      height: function(state, height) { 
        state.height = height;
      },
    }
  }
  export default equipment
  